import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "masterplan-view" }
const _hoisted_2 = {
  key: 0,
  class: "masterplan-loading-overlay"
}
const _hoisted_3 = { class: "overlay-percent" }
const _hoisted_4 = { class: "percent-num" }
const _hoisted_5 = {
  key: 1,
  class: "error"
}
const _hoisted_6 = {
  key: 2,
  class: "no-masterplan"
}
const _hoisted_7 = {
  key: 3,
  class: "masterplan-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "overlay-fade" }, {
      default: _withCtx(() => [
        ($setup.overlayVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString($setup.loadingPercent), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "percent-sign" }, "%", -1))
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "overlay-label" }, "Loading masterplan", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!$setup.loading && !$setup.error && !$setup.isEmbedded)
      ? (_openBlock(), _createBlock($setup["CustomerNavbar"], {
          key: 0,
          logoUrl: $setup.projectPageData?.landSubContent?.projectLogoUrl || $setup.projectPageData?.residentialContent?.logoImageUrl,
          brandText: $setup.projectPageData?.landSubContent?.projectName || $setup.projectPageData?.residentialContent?.brandText || $setup.estateName,
          onBack: $setup.goBack
        }, null, 8, ["logoUrl", "brandText"]))
      : _createCommentVNode("", true),
    (!$setup.loading && $setup.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString($setup.error), 1)
        ]))
      : (!$setup.loading && !$setup.hasMasterplan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("p", null, "No interactive masterplan found for this estate.", -1)
          ]))]))
        : (!$setup.loading && $setup.hasMasterplan)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode($setup["InteractiveMasterplan"], {
                estateId: $setup.estateId,
                role: $setup.UserRoles.CUSTOMER,
                isEmbedded: $setup.isEmbedded,
                "initial-masterplan": $setup.masterplanData,
                "estate-name": $setup.estateName,
                "matching-house-design-id": $setup.matchingHouseDesignId,
                "matching-facade-id": $setup.matchingFacadeId,
                onMapReady: $setup.onMapReady,
                onLotModalVisibilityChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.isLotDetailModalOpen = $event)),
                onMobileMapExpandedChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.isMobileMapExpanded = $event))
              }, null, 8, ["estateId", "role", "isEmbedded", "initial-masterplan", "estate-name", "matching-house-design-id", "matching-facade-id"])
            ]))
          : _createCommentVNode("", true),
    (!$setup.loading && !$setup.error && $setup.hasMasterplan && !$setup.isLotDetailModalOpen && !$setup.isMobileMapExpanded)
      ? (_openBlock(), _createBlock($setup["CustomerBottomNavigation"], {
          key: 4,
          currentView: "map",
          onNavigate: $setup.handleBottomNavigate,
          showHomeDesigns: !$setup.isLandSubdivision
        }, null, 8, ["showHomeDesigns"]))
      : _createCommentVNode("", true)
  ]))
}